"use client";

import { useSearchParams } from 'next/navigation';
import { ContactForm } from '@/components/forms/ContactForm';

export default function ContactFormLoader() {
  const searchParams = useSearchParams();
  const preselect = searchParams.get('preselect') || undefined;
  const type = searchParams.get('type') || undefined;
  const role = searchParams.get('role') || undefined;
  const sourceUrl = searchParams.get('sourceUrl') || (typeof window !== 'undefined' ? window.location.pathname : undefined); // Get sourceUrl or fallback to current path

  return <ContactForm preselect={preselect} type={type} role={role} sourceUrl={sourceUrl} />;
} 